var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLogoBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.1786 12.3848H4.82143C2.15865 12.3848 0 14.5434 0 17.2062V62.7934C0 65.4561 2.15865 67.6148 4.82143 67.6148H75.1786C77.8414 67.6148 80 65.4561 80 62.7934V17.2062C80 14.5434 77.8414 12.3848 75.1786 12.3848Z",
    fill: "#274D79"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4712 25.8379V33.6903C55.4712 34.9233 56.4707 35.9227 57.7036 35.9227H70.0211C71.2541 35.9227 72.2535 34.9232 72.2535 33.6903V25.8379C72.2535 24.6048 71.254 23.6055 70.0211 23.6055H57.7038C56.4707 23.6055 55.4712 24.605 55.4712 25.8379Z",
    fill: "#C4573A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.90771 20.3096H11.3782C12.0651 20.3096 12.5774 20.3383 12.915 20.3955C13.2526 20.4527 13.5546 20.5721 13.8211 20.7537C14.0876 20.9353 14.3097 21.1772 14.4874 21.4793C14.665 21.7813 14.7539 22.1199 14.7539 22.4949C14.7539 22.9015 14.6444 23.2746 14.4252 23.6142C14.206 23.9538 13.9089 24.2083 13.5339 24.3781C14.063 24.5321 14.4696 24.7946 14.7539 25.1659C15.0381 25.5369 15.1803 25.9732 15.1803 26.4746C15.1803 26.8694 15.0885 27.2534 14.9049 27.6265C14.7212 27.9996 14.4706 28.2977 14.1527 28.5209C13.8349 28.744 13.4431 28.8811 12.9772 28.9324C12.6851 28.964 11.9802 28.9836 10.863 28.9917H7.90771V20.3096ZM9.66064 21.7545V23.7621H10.8095C11.4925 23.7621 11.917 23.7522 12.0827 23.7326C12.3827 23.697 12.6186 23.5933 12.7905 23.4216C12.9623 23.25 13.0481 23.0239 13.0481 22.7436C13.0481 22.4751 12.9741 22.2571 12.826 22.0891C12.6779 21.9212 12.4579 21.8197 12.1657 21.7842C11.992 21.7644 11.4927 21.7547 10.6674 21.7547H9.66064V21.7545ZM9.66064 25.2072V27.5288H11.2834C11.9151 27.5288 12.3159 27.5111 12.4855 27.4755C12.7461 27.4282 12.9584 27.3127 13.1222 27.1291C13.2861 26.9454 13.3681 26.6998 13.3681 26.3918C13.3681 26.1312 13.3048 25.91 13.1786 25.7284C13.0524 25.5468 12.8697 25.4146 12.6307 25.3316C12.3917 25.2485 11.8736 25.2072 11.0762 25.2072H9.66064V25.2072Z",
    fill: "#EBF0F3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4901 28.9917H22.5831L21.8251 27.0196H18.3547L17.638 28.9917H15.7783L19.16 20.3096H21.0137L24.4901 28.9917ZM21.2624 25.5567L20.0661 22.335L18.8935 25.5567H21.2624Z",
    fill: "#EBF0F3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4375 28.9917V20.3096H27.1431L30.6964 26.1075V20.3096H32.325V28.9917H30.5661L27.066 23.3299V28.9917H25.4375Z",
    fill: "#EBF0F3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2026 28.9917V20.3096H35.9556V24.1649L39.4971 20.3096H41.8543L38.5852 23.6912L42.0319 28.9917H39.7636L37.3769 24.9171L35.9556 26.368V28.9917H34.2026V28.9917Z",
    fill: "#EBF0F3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1583 55.4561H4.36475V59.6919H11.1583V55.4561Z",
    fill: "#EBF0F3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.392 55.4561H16.6826V59.6919H27.392V55.4561Z",
    fill: "#EBF0F3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7298 55.4561H30.6348V59.6919H42.7298V55.4561Z",
    fill: "#EBF0F3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8254 55.4561H46.7305V59.6919H60.8254V55.4561Z",
    fill: "#EBF0F3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6352 55.4561H65.4443V59.6919H75.6352V55.4561Z",
    fill: "#EBF0F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogoBank);
export default __webpack_public_path__ + "static/media/IconLogoBank.59bbdcb6ea39d3b668c6fef7b22e5db7.svg";
export { ForwardRef as ReactComponent };